/**
 * Format any ISO / parseable date string as "DD Month YYYY" (e.g. 14 May 2026).
 *
 * Examples:
 *   formatVoucherDate('2026-05-14')              -> '14 May 2026'
 *   formatVoucherDate('2026-05-14T10:00:00Z')    -> '14 May 2026'
 *   formatVoucherDate('14 May 2026')             -> '14 May 2026'
 *   formatVoucherDate(null)                      -> ''
 *   formatVoucherDate('not-a-date')              -> 'not-a-date'  (verbatim)
 */
export function formatVoucherDate(dateStr) {
  if (!dateStr) return '';
  const date = new Date(dateStr);
  if (isNaN(date.getTime())) return String(dateStr);
  const day = String(date.getDate()).padStart(2, '0');
  const month = date.toLocaleString('en-GB', { month: 'long' });
  const year = date.getFullYear();
  return `${day} ${month} ${year}`;
}
